import type { AxiosHeaders } from 'axios';

export const SQL_CAPTURE_HEADER = 'x-capture-sql';
export const SQL_CAPTURE_HEADER_VALUE = '1';

export function requestSqlCapture(headers: AxiosHeaders): void {
  headers.set(SQL_CAPTURE_HEADER, SQL_CAPTURE_HEADER_VALUE);
}

export function isSqlCaptureRequested(headers?: AxiosHeaders): boolean {
  return headers?.get(SQL_CAPTURE_HEADER) === SQL_CAPTURE_HEADER_VALUE;
}
